import { ResourceOptions } from 'react-admin';
import { FaUserShield } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingAccounts;
export const icon = FaUserShield;
export const options: ResourceOptions = {
  label: 'module.socialTrading.accounts',
};
